var render = function render(){var _vm=this,_c=_vm._self._c;return _c('svg',_vm._g({attrs:{"xmlns":"http://www.w3.org/2000/svg","viewBox":"0 0 14 8","width":"14","height":"8","stroke":"currentColor"}},_vm.$listeners),[_c('path',{attrs:{"d":"M12.657 1L7 6.657 1.343 1","stroke-width":"2","fill":"none"}})])
}
var staticRenderFns = []

export { render, staticRenderFns }